module.exports = __webpack_public_path__ + "00747ce0babbb4b6b4f702eab88ead9a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-s.png
// module id = 3302
// module chunks = 0